import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Collapse from '@mui/material/Collapse';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Button from '@ts-core/components/Button';
import Typography from '@ts-core/components/Typography';

import AssignmentListCard from '../AssignmentListCard';

const useStyles = makeStyles((theme) => ({
  expandButton: {
    marginLeft: -8,
    fontWeight: 500,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

const AssignmentListSection = (props) => {
  const classes = useStyles();
  const { section, loading, onToggleSection, onSelectAssignment, onRemoveAssignment, onSendAssignment, onEditAssignment, onToggleAssignment, open } =
    props;

  const { title, assignments: pAssignments } = section;

  const assignments = loading ? Array.from(new Array(3)) : pAssignments;

  const handleToggleSection = useCallback(() => {
    onToggleSection(section);
  }, [section, onToggleSection]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Button
          disabled={loading}
          onClick={handleToggleSection}
          aria-expanded={open}
          aria-label="mostrar entregas"
          className={classes.expandButton}
          disableRipple
          size="large"
        >
          <Typography variant="h6" loading={loading} skeletonWidth={120} color="secondary">
            {title}
          </Typography>
          <ExpandMoreIcon
            color="secondary"
            className={classnames(classes.expand, {
              [classes.expandOpen]: open,
            })}
          />
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Grid container spacing={2}>
            {assignments.map((assignment, index) => (
              <Grid item xs={12} sm={6} md={3} key={assignment?._id || index}>
                <AssignmentListCard
                  assignment={assignment}
                  loading={loading}
                  onToggleAssignment={onToggleAssignment}
                  onSelectAssignment={onSelectAssignment}
                  onRemoveAssignment={onRemoveAssignment}
                  onSendAssignment={onSendAssignment}
                  onEditAssignment={onEditAssignment}
                />
              </Grid>
            ))}
          </Grid>
        </Collapse>
      </Grid>
    </Grid>
  );
};

AssignmentListSection.propTypes = {
  loading: PropTypes.bool,
  section: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    assignments: PropTypes.array,
  }),
  onToggleSection: PropTypes.func.isRequired,
  open: PropTypes.bool,

  onToggleAssignment: PropTypes.func.isRequired,
  onSelectAssignment: PropTypes.func.isRequired,
  onRemoveAssignment: PropTypes.func.isRequired,
  onSendAssignment: PropTypes.func.isRequired,
  onEditAssignment: PropTypes.func.isRequired,
};

AssignmentListSection.defaultProps = {
  loading: false,
  open: false,
  section: {},
};

export default AssignmentListSection;
